import {clsx} from 'clsx'
import {FC} from 'react'
import s from '../index.module.css'
import Arrow from './arrow'
import Image from 'next/image'

type Props = {
  direction: 'left' | 'right'
  onClick: () => void
}

const ArrowButton: FC<Props> = ({direction, onClick}) => (
  <button
    onClick={onClick}
    className={clsx(s.arrow, {[s.leftArrow]: direction === 'left', [s.rightArrow]: direction === 'right'})}
  >
    <div className={clsx({[s.rotate_180]: direction === 'left'})}>
      <Image
        src='https://static.gamezop.com/comet/assets/img2/slider-right-arrow.svg'
        width={10}
        height={19}
        alt={direction === 'left' ? 'slider left arrow' : 'slider right arrow'}
      />
    </div>
  </button>
)

export default ArrowButton
